module.exports = __webpack_public_path__ + "static/GlitchlessSonyax53-83d467fc7e6ffd974baa6580714ea76c.png";